"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8014],{

/***/ 58014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(39803);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(7397);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(30553);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80797);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(30585);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11719);
/* harmony import */ var _components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62412);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(19337);
/* harmony import */ var _layouts_QuickBriefGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46275);
/* harmony import */ var _utility_cr_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46236);
/* harmony import */ var _components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53056);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34853);
/* harmony import */ var _components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97344);
/* harmony import */ var _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66306);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5969);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31955);
/* harmony import */ var _components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98950);
/* harmony import */ var _utility_services_customHooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89147);
/* harmony import */ var _components_CreditsInfo__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98910);























var useStyles = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(theme) {
    return {
        buttonGroup: {
            display: "flex",
            justifyContent: "flex-end"
        }
    };
});
var WriteContentBrief = function(param) {
    var classes = param.classes, setShowSignUpPage = param.setShowSignUpPage, user = param.user, hasValidSubscription = param.hasValidSubscription, resetLockedGrace = param.resetLockedGrace, enableLockedOption = param.enableLockedOption, handleResetUsage = param.handleResetUsage, _isQwaDashboard = param.isQwaDashboard, isQwaDashboard = _isQwaDashboard === void 0 ? false : _isQwaDashboard, _isCreditsShown = param.isCreditsShown, isCreditsShown = _isCreditsShown === void 0 ? false : _isCreditsShown, _creditsRemaining = param.creditsRemaining, creditsRemaining = _creditsRemaining === void 0 ? 0 : _creditsRemaining, _usagePerDay = param.usagePerDay, usagePerDay = _usagePerDay === void 0 ? 0 : _usagePerDay, setShowBuyOnePass = param.setShowBuyOnePass, setIsRedirectToWebflow = param.setIsRedirectToWebflow, _setShowMinimumCreditsNeededMsg = param.setShowMinimumCreditsNeededMsg, setShowMinimumCreditsNeededMsg = _setShowMinimumCreditsNeededMsg === void 0 ? function(a) {} : _setShowMinimumCreditsNeededMsg, setShowVerifyEmailPopup = param.setShowVerifyEmailPopup, _freeToolsUsage = param.freeToolsUsage, freeToolsUsage = _freeToolsUsage === void 0 ? 0 : _freeToolsUsage, _showFreeToolsUsage = param.showFreeToolsUsage, showFreeToolsUsage = _showFreeToolsUsage === void 0 ? false : _showFreeToolsUsage, _isCorpEmail = param.isCorpEmail, isCorpEmail = _isCorpEmail === void 0 ? false : _isCorpEmail;
    var ownClasses = useStyles();
    var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_12__/* ["default"].get */ .Z.get("qttr_tools_auth");
    var qttr_tools_daypass_auth = js_cookie__WEBPACK_IMPORTED_MODULE_12__/* ["default"].get */ .Z.get("qttr_tools_daypass_auth");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), pageTopic = ref[0], setPageTopic = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("Blog"), articleType = ref1[0], setArticleType = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("Formal"), writingStyle = ref2[0], setWritingStyle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("1,000 Words"), wordCount = ref3[0], setWordCount = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), targetAudience = ref4[0], setTargetAudience = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), outcome = ref5[0], setOutCome = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), contentBrief = ref7[0], setContentBrief = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isMounted = ref8[0], setIsMounted = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), error = ref9[0], setError = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), copied = ref10[0], setCopied = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        title: false,
        H1: false,
        meta: false,
        H2: false,
        H3: false,
        H4: false,
        images: false,
        schema: false
    }), suggestions = ref11[0], setSuggestions = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), additionalInstructions = ref12[0], setAdditionalInstructions = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), recaptchaValue = ref13[0], setRecaptchaValue = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), captchaError = ref14[0], setCaptchaError = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), creditsNeeded = ref15[0], setCreditsNeeded = ref15[1];
    var inputSelectionRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var session = (0,_utility_services_customHooks__WEBPACK_IMPORTED_MODULE_14__/* .useSession */ .kP)();
    var handleRecaptchaChange = function(value) {
        setRecaptchaValue(value);
        setCaptchaError("");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
            isAnonymousUser: !user,
            payload: {
                label: "Visited Free Tool",
                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                isQwaDashboard: isQwaDashboard
            }
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsMounted(true);
    }, []);
    var handleCheckboxChange = function(name) {
        setSuggestions(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, name, !prev[name]));
        });
    };
    var generateContentBrief = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var isInputValid, selectedOptions, headingsSelected, otherTags, withWebPageSchemaM, res, axiosError;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (pageTopic) {
                            _ctx.next = 4;
                            break;
                        }
                        setError("pageTopic");
                        return _ctx.abrupt("return");
                    case 4:
                        if (recaptchaValue || qttr_tools_auth || user) {
                            _ctx.next = 7;
                            break;
                        }
                        setCaptchaError("recaptchaValue");
                        return _ctx.abrupt("return");
                    case 7:
                        setCaptchaError("");
                        setError("");
                        setLoading(true);
                        isInputValid = pageTopic && articleType && writingStyle && wordCount;
                        if (isInputValid) {
                            _ctx.next = 14;
                            break;
                        }
                        setError("Both keyword and description are required");
                        return _ctx.abrupt("return");
                    case 14:
                        selectedOptions = Object.keys(suggestions).filter(function(i) {
                            return suggestions[i];
                        });
                        headingsSelected = (0,_layouts_QuickBriefGenerator__WEBPACK_IMPORTED_MODULE_4__/* .getHeadings */ .o3)(selectedOptions.filter(function(i) {
                            return [
                                "H2",
                                "H3",
                                "H4"
                            ].includes(i);
                        }));
                        otherTags = selectedOptions.filter(function(i) {
                            return ![
                                "H2",
                                "H3",
                                "H4",
                                "Schema"
                            ].includes(i);
                        });
                        withWebPageSchemaM = selectedOptions.includes("Schema") ? "and web page schema markup" : "";
                        _ctx.next = 20;
                        return (0,_utility_cr_common__WEBPACK_IMPORTED_MODULE_5__/* .fetchAIBasedContent */ .LK)({
                            promptFor: "PUBLIC_UTILITY.CONTENT_BRIEF",
                            promptConfig: {
                                articleTypeText: _layouts_QuickBriefGenerator__WEBPACK_IMPORTED_MODULE_4__/* .ArticleTypeToText */ .O1[articleType] || "",
                                articleType: articleType,
                                pageTopic: pageTopic,
                                writingStyle: writingStyle,
                                articleLength: wordCount,
                                outcome: outcome,
                                initialHeadingSuggestions: headingsSelected,
                                suggestSchema: selectedOptions.includes("Schema") ? "true" : "",
                                additionalInstructions: additionalInstructions,
                                otherTags: otherTags ? otherTags.join(",") : "",
                                withWebPageSchemaM: withWebPageSchemaM,
                                selectedOptions: selectedOptions,
                                targetAudience: targetAudience
                            },
                            tokenLimit: 3500,
                            isPublicApi: true,
                            reCAPTCHAToken: recaptchaValue
                        });
                    case 20:
                        res = _ctx.sent;
                        if (res) {
                            (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                                eventFor: "button",
                                buttonText: "",
                                counterName: "".concat(_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools, " Outputs"),
                                isAddCount: true,
                                user: user,
                                isAnonymousUser: !user,
                                payload: {
                                    label: "Generate Output",
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                    number_suggestions: Object.values(suggestions).filter(Boolean).length,
                                    special_instructions_yn: additionalInstructions ? "Yes" : "No",
                                    isQwaDashboard: isQwaDashboard,
                                    creditsConsumed: creditsNeeded ? creditsNeeded : 1
                                }
                            });
                            if (handleResetUsage) {
                                handleResetUsage();
                            }
                        }
                        setContentBrief(res);
                        if (resetLockedGrace) {
                            resetLockedGrace();
                            setTargetAudience("");
                            setSuggestions((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, suggestions), {
                                images: false,
                                schema: false
                            }));
                        }
                        _ctx.next = 31;
                        break;
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](0);
                        axiosError = _ctx.t0;
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            if (axiosError.response.status === 403) {
                                setShowSignUpPage(_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_9__/* .CONTINUE_USING_TEXT */ .gt, {
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                });
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    isAnonymousUser: !user,
                                    payload: {
                                        label: "Reached your maximum usage limit",
                                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                        isQwaDashboard: isQwaDashboard
                                    }
                                });
                            }
                        }
                        console.error("generateContentBrief::error", _ctx.t0);
                    case 31:
                        _ctx.prev = 31;
                        setRecaptchaValue(null);
                        (0,_utility_common__WEBPACK_IMPORTED_MODULE_11__/* .resetCaptcha */ .Ler)();
                        setLoading(false);
                        return _ctx.finish(31);
                    case 36:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    26,
                    31,
                    36
                ]
            ]);
        }));
        return function generateContentBrief() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCopyText = function() {
        var inputElement = inputSelectionRef === null || inputSelectionRef === void 0 ? void 0 : inputSelectionRef.current;
        if (inputElement) {
            var ref;
            var copiedText = inputElement === null || inputElement === void 0 ? void 0 : (ref = inputElement.value) === null || ref === void 0 ? void 0 : ref.substring((inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionStart) || 0, (inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionEnd) || 0);
            if (copiedText) {
                navigator.clipboard.writeText(copiedText);
                setCopied(true);
                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                    eventFor: "button",
                    buttonText: "",
                    counterName: "Outputs Accepted",
                    isAddCount: true,
                    user: user,
                    isAnonymousUser: !user,
                    payload: {
                        label: "Copy Generated Output",
                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                        number_suggestions: Object.values(suggestions).filter(Boolean).length,
                        special_instructions_yn: additionalInstructions ? "Yes" : "No",
                        isQwaDashboard: isQwaDashboard,
                        isManualCopy: true
                    }
                });
            } else {
                navigator.clipboard.writeText(contentBrief);
                setCopied(true);
                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                    eventFor: "button",
                    buttonText: "",
                    counterName: "Outputs Accepted",
                    isAddCount: true,
                    user: user,
                    isAnonymousUser: !user,
                    payload: {
                        label: "Copy Generated Output",
                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                        number_suggestions: Object.values(suggestions).filter(Boolean).length,
                        special_instructions_yn: additionalInstructions ? "Yes" : "No",
                        isQwaDashboard: isQwaDashboard
                    }
                });
            }
        }
        setTimeout(function() {
            setCopied(false);
        }, 2000); // Change the text back to 'Copy Text' after 2 seconds
    };
    var UpdatedSelectedOptions = Object.keys(suggestions).filter(function(i) {
        return suggestions[i];
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var promptFor = _utility_common__WEBPACK_IMPORTED_MODULE_11__/* .PAID_TOOLS_PROMPT_FOR.CONTENT_BRIEF_GENERATOR */ .rMq.CONTENT_BRIEF_GENERATOR;
        var promptConfig = {
            selectedOptions: UpdatedSelectedOptions,
            targetAudience: targetAudience
        };
        setCreditsNeeded((0,_utility_common__WEBPACK_IMPORTED_MODULE_11__/* .getToolsUsageCreditsNeeded */ .Nmb)(promptFor, promptConfig));
    }, [
        user,
        UpdatedSelectedOptions,
        targetAudience
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: contentBrief ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    inputRef: inputSelectionRef,
                    fullWidth: true,
                    multiline: true,
                    rows: (0,_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_9__/* .calculateRows */ .Gm)(contentBrief),
                    margin: "normal",
                    placeholder: "Generated Title Tag",
                    value: contentBrief,
                    className: "".concat(classes.textAreaInput, " no-border background-gray"),
                    maxRows: 200,
                    InputProps: {
                        style: {
                            borderRadius: "4px !important",
                            padding: "16px"
                        }
                    },
                    minRows: 20,
                    variant: "outlined",
                    onCopy: handleCopyText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: classes.buttonGroup,
                    style: {
                        marginTop: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA, " ").concat(classes.button),
                            disabled: loading,
                            style: {
                                float: "right"
                            },
                            onClick: function() {
                                setContentBrief("");
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                                    eventName: "Clicked on Go back",
                                    payload: {
                                        label: "Clicked on Go back"
                                    }
                                });
                            },
                            children: "Go back"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            className: "".concat(classes.toolsYellowCTA, " ").concat(classes.button),
                            disabled: loading,
                            style: {
                                float: "right"
                            },
                            onClick: handleCopyText,
                            children: copied ? "Copied!" : "Copy Text"
                        })
                    ]
                })
            ]
        }) : isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: classes.container,
                children: [
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_6__/* .QuattrLogoSpinner */ .h, {
                        classes: classes
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        fullWidth: true,
                        label: "Enter Page Topic",
                        value: pageTopic,
                        variant: "outlined",
                        className: "".concat(classes.textAreaInput, " no-border"),
                        onChange: function(e) {
                            return setPageTopic(e.target.value);
                        },
                        error: !!error,
                        helperText: error.includes("pageTopic") ? "* Required" : error.includes("Please sign up") ? error : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    label: "Type of Article",
                                    value: articleType,
                                    classes: classes,
                                    options: _layouts_QuickBriefGenerator__WEBPACK_IMPORTED_MODULE_4__/* .ArticleTypes */ .po,
                                    onChange: function(e) {
                                        setArticleType(e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    label: "Writing Style",
                                    value: writingStyle,
                                    classes: classes,
                                    options: _layouts_QuickBriefGenerator__WEBPACK_IMPORTED_MODULE_4__/* .writingStyles */ .wW,
                                    onChange: function(e) {
                                        setWritingStyle(e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    label: "Tentative Word Count",
                                    value: wordCount,
                                    classes: classes,
                                    options: _layouts_QuickBriefGenerator__WEBPACK_IMPORTED_MODULE_4__/* .lengthOfArticle */ .TO,
                                    onChange: function(e) {
                                        setWordCount(e.target.value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    fullWidth: true,
                                    placeholder: "Target Audience",
                                    variant: "outlined",
                                    inputProps: {
                                        readOnly: !hasValidSubscription && !enableLockedOption ? true : false
                                    },
                                    className: "".concat(classes.textAreaInput, " Mui-disabled  no-border m-0"),
                                    value: targetAudience,
                                    onClick: function() {
                                        if (setShowSignUpPage && !hasValidSubscription && !enableLockedOption) {
                                            setShowSignUpPage("'Add target Audience'", {
                                                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                                                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                            });
                                            (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                                                eventFor: "button",
                                                isAnonymousUser: !user,
                                                payload: {
                                                    label: "Clicked Locked Option",
                                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                                    option_name: "Add target Audience",
                                                    isQwaDashboard: isQwaDashboard
                                                }
                                            });
                                        }
                                    },
                                    onChange: function(e) {
                                        return setTargetAudience(e.target.value);
                                    },
                                    InputProps: {
                                        endAdornment: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                            position: "end",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                                className: classes.lockIcon
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 18 18",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                                                fill: "#FFC72C"
                                            })
                                        })
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        className: "".concat(classes.textAreaInput, " no-border mb-0"),
                        fullWidth: true,
                        multiline: true,
                        rows: 4,
                        maxRows: 4,
                        variant: "outlined",
                        label: "Describe the outcome you are hoping to achieve from this page",
                        value: outcome,
                        onChange: function(e) {
                            return setOutCome(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                className: classes.sectionSubHeading,
                                children: "Add Suggestions For"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                container: true,
                                spacing: 3,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        container: true,
                                        spacing: 2,
                                        children: Object.keys(suggestions).map(function(key, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                                item: true,
                                                xs: 4,
                                                sm: 3,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                    control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                                            checked: suggestions[key],
                                                            onChange: function() {
                                                                if (hasValidSubscription || enableLockedOption || key !== "images" && key !== "schema") {
                                                                    handleCheckboxChange(key);
                                                                } else if (!hasValidSubscription && !enableLockedOption) {
                                                                    setShowSignUpPage('"get '.concat(key, ' Suggestions"'), {
                                                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                                                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                                                    });
                                                                    (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec)({
                                                                        eventFor: "button",
                                                                        isAnonymousUser: !user,
                                                                        payload: {
                                                                            label: "Clicked Locked Option",
                                                                            component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                                                            screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                                                            tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                                                                            tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                                                            option_name: "".concat(key, " Suggestions"),
                                                                            isQwaDashboard: isQwaDashboard
                                                                        }
                                                                    });
                                                                }
                                                            },
                                                            icon: (key === "images" || key === "schema") && !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                                                style: {
                                                                    marginRight: 8
                                                                }
                                                            }) : undefined
                                                        })
                                                    }),
                                                    label: (key === "images" || key === "schema") && (hasValidSubscription || enableLockedOption) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "5px"
                                                        },
                                                        children: [
                                                            (0,lodash__WEBPACK_IMPORTED_MODULE_7__.capitalize)(key),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 18 18",
                                                                fill: "none",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                                                                    fill: "#FFC72C"
                                                                })
                                                            })
                                                        ]
                                                    }) : key ? (0,lodash__WEBPACK_IMPORTED_MODULE_7__.capitalize)(key) : null
                                                })
                                            }, index);
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        fullWidth: true,
                        multiline: true,
                        label: "Additional instructions you would like to include",
                        value: additionalInstructions,
                        onChange: function(e) {
                            return setAdditionalInstructions(e.target.value);
                        },
                        className: "".concat(classes.textAreaInput, " no-border"),
                        rows: 4,
                        maxRows: 4,
                        variant: "outlined"
                    }),
                    !qttr_tools_auth && !user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                className: classes.recaptcha,
                                sitekey: "6LfNnmAqAAAAAFm-6SDC8c9lFenCJX2_QkckWpsd",
                                onChange: handleRecaptchaChange
                            }),
                            (captchaError === null || captchaError === void 0 ? void 0 : captchaError.includes("recaptchaValue")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                className: "red",
                                children: "Please complete the reCAPTCHA to verify you're human."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_13__/* .SkipCaptcha */ .h, {
                                classes: classes,
                                meta: {
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_NAME.content_brief_generator */ .vG.content_brief_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                },
                                setShowVerifyEmailPopup: setShowVerifyEmailPopup
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "".concat(isCreditsShown ? classes.creditsShown : classes.freeCreditsShown),
                        children: [
                            isCreditsShown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: creditsRemaining,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: usagePerDay
                            }) : !isQwaDashboard || showFreeToolsUsage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: freeToolsUsage,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: isCorpEmail ? 10 : 7,
                                showFreeToolsUsage: showFreeToolsUsage
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "d-flex ".concat(classes.buttonGroup),
                                style: {
                                    marginTop: "16px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                    className: classes.toolsYellowCTA,
                                    onClick: function() {
                                        return (0,_utility_common__WEBPACK_IMPORTED_MODULE_11__/* .handleGenerateOutput */ .jx$)(creditsRemaining, creditsNeeded, isQwaDashboard, session, qttr_tools_daypass_auth, setShowMinimumCreditsNeededMsg, setShowBuyOnePass, generateContentBrief, _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_10__/* .trackAnalyticsEvent */ .ec, freeToolsUsage, showFreeToolsUsage);
                                    },
                                    children: "Generate Content Brief"
                                })
                            })
                        ]
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WriteContentBrief);


/***/ })

}]);